import React from 'react';
import { ProductCard } from '../../components/ui/ProductCard';
export function AutomationSection() {
  return <section id="automation" className="py-6 bg-gray-50" data-id="element-2538">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2539">
        <h3 className="text-2xl font-bold text-navy mb-6" data-id="element-2540">Automation</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2541">
          <ProductCard title="Automation" description="Machine tool automation solutions to improve throughput and consistency." href="59m7/automation.html" imageSrc="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/GFMS/System%203R%20Automation.png800x800.png" imageAlt="Machine tool automation" data-id="element-2542" />
        </div>
      </div>
    </section>;
}